import Mergeable from "./Mergeable";

class Exportable extends Mergeable {
  export() {
    throw new Error('Must be overridden');
  }
}

export default Exportable;
